import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getClassnamesBasedOnCondition = (
  condition: boolean,
  className: string,
) => {
  return condition ? className : '';
};

export const getClassOrDefault = (
  className: string,
  defaultClassName: string,
) => {
  if (className) {
    return `--${className}`;
  }
  return defaultClassName;
};
